// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Square_wrapper__1MpOH"};